// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: Apache-2.0
import { useCallback } from "react";
import { KeyCode } from "../../../keycode";
var HOME = 36;
var END = 35;
export var useMenuKeyboard = function(_a) {
    var moveHighlight = _a.moveHighlight, selectOption = _a.selectOption, goHome = _a.goHome, goEnd = _a.goEnd, closeDropdown = _a.closeDropdown, isSelectingUsingSpace = _a.isSelectingUsingSpace, _b = _a.preventNativeSpace, preventNativeSpace = _b === void 0 ? false : _b;
    return useCallback(function(e) {
        switch(e.detail.keyCode){
            case KeyCode.up:
                e.preventDefault();
                moveHighlight(-1);
                break;
            case KeyCode.down:
                e.preventDefault();
                moveHighlight(1);
                break;
            case HOME:
                goHome();
                break;
            case END:
                goEnd();
                break;
            case KeyCode.escape:
                closeDropdown();
                break;
            case KeyCode.enter:
                e.preventDefault();
                selectOption();
                break;
            case KeyCode.space:
                if (preventNativeSpace) {
                    e.preventDefault();
                    selectOption();
                    isSelectingUsingSpace.current = true;
                }
        }
    }, [
        moveHighlight,
        selectOption,
        goHome,
        goEnd,
        closeDropdown,
        isSelectingUsingSpace,
        preventNativeSpace
    ]);
};
export var useTriggerKeyboard = function(_a) {
    var openDropdown = _a.openDropdown, goHome = _a.goHome;
    return useCallback(function(e) {
        switch(e.detail.keyCode){
            case KeyCode.up:
            case KeyCode.down:
                e.preventDefault();
                goHome();
                openDropdown();
                break;
            case KeyCode.space:
                e.preventDefault();
                openDropdown();
                break;
        }
    }, [
        openDropdown,
        goHome
    ]);
}; //# sourceMappingURL=use-keyboard.js.map
